import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import { styled } from 'styled-components'

export const ScrollArea = ScrollAreaPrimitive.Root
export const ScrollAreaViewport = ScrollAreaPrimitive.Viewport

export const StyledScrollAreaRoot = styled(ScrollArea)`
  max-height: 60vh;
  overflow: auto;
`

export const StyledScrollAreaViewport = styled(ScrollAreaViewport)`
  width: 100%;
  height: 100%;
`
